import { render, staticRenderFns } from "./TagSelect.vue?vue&type=template&id=512ef130&scoped=true&"
import script from "./TagSelect.vue?vue&type=script&lang=js&"
export * from "./TagSelect.vue?vue&type=script&lang=js&"
import style0 from "./TagSelect.vue?vue&type=style&index=0&id=512ef130&scoped=true&lang=css&"
import style1 from "./TagSelect.vue?vue&type=style&index=1&id=512ef130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512ef130",
  null
  
)

export default component.exports